// extracted by mini-css-extract-plugin
export default {"personal":"delivery_personal__QzV+I","option":"delivery_option__ix5Sh","picked":"delivery_picked__8Izm8","button":"delivery_button__c5uJN","selected":"delivery_selected__GTVHU"};